export const DASHBOARD_DATE_PICKER_CHANGE = 'DASHBOARD_DATE_PICKER_CHANGE';
